let scrollButton

const footerInit = () => {
  scrollButton = document.getElementById("scroll-to-top-k");
  if (scrollButton) {
    window.addEventListener('scroll', scrollFunction);
    scrollButton.addEventListener("click", () => {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0;
    });
  }
}

const scrollFunction = () => {
  if (document.body.scrollTop > 600 || document.documentElement.scrollTop > 600) {
    scrollButton.style.opacity = 1;
  } else {
    scrollButton.style.opacity = 1;
  }
}

window.addEventListener('load', footerInit)

